<script lang="ts">
export default {
  name: 'Tooltip',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { TooltipContent, TooltipPortal, TooltipProvider, TooltipRoot, TooltipTrigger } from 'reka-ui';

const props = withDefaults(
  defineProps<{
    text: string;
    position?: 'top' | 'bottom' | 'left' | 'right';
    disabled?: boolean;
    /** Hover delay before the tooltip opens (ms). Reka `TooltipProvider` default is 700; we default to 0 for instant tooltips. */
    delayDuration?: number;
    class?: string;
  }>(),
  {
    position: 'top',
    disabled: false,
    delayDuration: 0,
  },
);

const activatorClasses = computed(() => {
  const classes: string[] = [];
  if (props.class) {
    classes.push(props.class);
  }
  return classes.join(' ');
});

const tooltipContentClasses = computed(() => {
  return ['z-[9999]', 'max-w-xs', 'rounded-lg', 'bg-neutral', 'px-3', 'py-2', 'text-sm', 'text-neutral-content', 'shadow-lg'].join(' ');
});
</script>

<template>
  <TooltipProvider :delay-duration="delayDuration">
    <TooltipRoot :disabled="disabled">
      <TooltipTrigger as-child>
        <span :class="activatorClasses">
          <slot />
        </span>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          :side="position"
          :side-offset="5"
          :class="tooltipContentClasses">
          {{ text }}
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
</template>
